export enum EditorModeType {
	EDIT = "edit",
	BOTH = "both",
	READ = "read",
}
